/* global G */
import ui from 'lib/hook/ui/update'
import validate from 'lib/hook/model/validate'
import confirm from 'lib/hook/router/confirm'
import seqMap from '@gaia/sequence/model/api/map'
import read from 'lib/hook/model/read'
import asObject from 'lib/sequence/component/children/asObject'
import session from 'app/_shared/session'
import provide from 'lib/hook/ui/provide'
import check from 'app/_shared/hook/check'
import back from 'app/_shared/hook/redirect/back'
import clear from 'app/_shared/hook/model/clear'
import { setKey } from 'lib/util'
import togglePhoneValidator from 'app/user/hook/togglePhoneValidator'
import reset from 'app/_shared/hook/component/reset'
import redirect from 'lib/hook/router/redirect'
import platform from 'app/_shared/hook/platform'
import quickActions from 'app/_shared/hook/appbar/quickActions'
import clean from 'app/_shared/hook/action/clean'
import onlineCheck from 'app/_shared/hook/onlineCheck'

const _baseHooks = {
  after: [
    ui,
  ],
}

const _formHooks = {
  before: [
    onlineCheck(),
    reset,
  ],
  after: [
    ui,
    confirm,
  ],
}

const _editHooks = {
  before: [
    onlineCheck(),
    obj => (...args) => {
      // todo: same as submitAttribute, we should create mapAttribute... :P
      seqMap(
        obj[G.MODEL][G.CHILDREN].person,
      )(
        asObject(obj[G.STATE][G.ACTION][G.COMPONENT][G.CHILDREN]).person,
      )
      return args
    },
  ],
  after: [
    ui,
    confirm,
  ],
}

const _avatarHooks = {
  before: [
    onlineCheck(),
    obj => (...args) => {
      // the attachment api expects to use our current model (which is the user), but we need to
      // tell it that we want to manage the person's attachments (avatar)
      const modelState = obj[G.MODEL][G.STATE]
      const { attachment } = asObject(obj[G.STATE][G.ACTION][G.COMPONENT][G.CHILDREN])
      const attachmentState = attachment[G.STATE]
      // eslint-disable-next-line prefer-destructuring
      const personRef = session(obj).person.key()
      attachmentState.value = personRef // upload
      modelState[G.REF] = personRef // listing
      return args
    },
  ],
  after: [
    ui,
    confirm,
  ],
}

const _submitHooks = {
  before: [
    togglePhoneValidator,
    validate,
  ],
  after: [
    ui,
    check,
    clear,
    back,
  ],
}

const _submitLanguageHooks = {
  before: [
    validate,
  ],
  after: [
    ui,
    check,
    clean,
    provide,
    clear,
    redirect,
  ],
}

const _profileHooks = {
  before: [
    // obj => async (...args) => (!obj[G.MODEL][G.CACHE]
    //   ? await recreate(obj)(args)
    //   : args),
    obj => (...args) => {
      const userId = session(obj).user.key()
      setKey(userId, G.REF, obj[G.MODEL][G.STATE])
      return args
    },
    read,
  ],
  after: [
    platform({
      mobile: quickActions,
    }),
    ui,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    profile: _profileHooks,
    avatar: _avatarHooks,
    edit: _editHooks,
    teams: _baseHooks,
    change: _formHooks,
    language: _editHooks,
    settings: _baseHooks,
    menu: _baseHooks,
    verify: _baseHooks,
    submit: _submitHooks,
    submitLanguage: _submitLanguageHooks,
    confirmRemove: _baseHooks,
  },
}

export default hooks
